export default {
  testnet: { chainId: '0xaa36a7' },
};
